import type { ErrorResponse } from './generated/v1/types.gen'

/**
 * Type guard for the API's `ErrorResponse` schema. Hey API throws typed errors
 * for non-2xx responses where the JSON body matches `{ errors: ErrorList[] }`.
 */
export function isErrorResponse(error: unknown): error is ErrorResponse {
  return (
    typeof error === 'object' &&
    error !== null &&
    'errors' in error &&
    Array.isArray((error as ErrorResponse).errors)
  )
}

/**
 * Pull a user-facing message out of an `ErrorResponse`-shaped API failure.
 * Joins the `detail` strings of every error so multi-field validation
 * failures surface the full list. Falls back to the provided message when
 * the payload does not match the schema.
 */
export function extractApiErrorMessage(error: unknown, fallback: string): string {
  if (isErrorResponse(error) && error.errors.length > 0) {
    const details = error.errors.map((e) => e.detail).filter(Boolean)
    if (details.length > 0) return details.join('. ')
  }
  return fallback
}
